<template>
    <!--Top Bar-->
    <TopBar msg="Welcome to Your Vue.js App" />



    <div class="category bg-background">

        <v-card elevation="0" rounded="0"
            class="bg-secondary mx-auto d-none d-md-block d-md-block d-lg-block d-xl-block d-xxl-block" height="150">
            <div class="d-flex flex-column fill-height justify-center align-center text-black">
                <h1 class="category-title-text">
                    {{ categoryDetail.name }}
                </h1>
            </div>
        </v-card>

        <v-card elevation="0"
            class="bg-secondary mx-auto rounded-xl mt-n6 d-block d-md-none d-md-none d-lg-none d-xl-none d-xxl-none "
            height="200">
            <v-layout>
                <v-main>
                    <!--main Category List-->
                    <AppMainCategory />
                    <!--main Category List-->
                </v-main>
            </v-layout>

            <div class="d-flex flex-column justify-center align-center text-black">
                <h1 class="mobile-category-title-text">
                    {{ categoryDetail.name }}
                </h1>
            </div>
        </v-card>

        <v-container>
            <v-row dense>
                <v-col cols="12" sm="12" md="12">
                    <!--Web View Tab screen-->
                    <v-card elevation="0"
                        class="bg-background rounded-xl mx-auto d-none d-sm-block d-md-block d-lg-block mt-n8"
                        max-width="1100">
                        <v-row dense>
                            <v-col cols="12">
                                <v-tabs v-model="categoryTab" bg-color="primary" slider-color="primary" color="white"
                                    grow selected-class="category-active" class="category-tab rounded-xl" height="45"
                                    show-arrows>
                                    <v-tab value="tab-all" elevation="0" hide-slider @click="categoryProduct('all')"
                                        class="rounded-xl">
                                        <!--<v-avatar class="mr-3">
                                            <v-img cover
                                                src="https://gourmetgarden.in/cdn/shop/files/Veg_3-min.jpg?v=1637668655">
                                            </v-img>
                                        </v-avatar>-->
                                        ALL
                                    </v-tab>
                                    <v-tab v-for="subCategory in subCategoryList" :key="subCategory.id"
                                        :value="'tab-' + subCategory.id" elevation="0"
                                        @click="categoryProduct(subCategory.id)" class="rounded-xl" hide-slider>
                                        <!--<v-avatar class="mr-3">
                                            <v-img cover :src="subCategory.image">
                                            </v-img>
                                        </v-avatar>-->
                                        {{ subCategory.name }}
                                    </v-tab>
                                </v-tabs>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="12" lg="12">
                                <v-window v-model="categoryTab" color="">
                                    <!--All Product Tab-->
                                    <v-window-item value="tab-all">
                                        <!--Products Web View-->
                                        <v-container>
                                            <v-row dense no-gutters>
                                                <v-col cols="1"></v-col>
                                                <v-col cols="8" sm="12" md="12" lg="12">
                                                    <v-sheet min-width="600" max-width="1150">
                                                        <div
                                                            class="d-sm-flex d-md-flex d-lg-flex flex-wrap justify-left bg-background">
                                                            <ProductCard :products="productList" />
                                                        </div>
                                                    </v-sheet>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                        <!--Products Web View-->
                                    </v-window-item>
                                    <!--All Product Tab End-->
                                    <v-window-item v-for="subCategory in subCategoryList" :key="subCategory.id"
                                        :value="'tab-' + subCategory.id">
                                        <!--Products Web View-->
                                        <v-container>
                                            <v-row dense no-gutters>
                                                <v-col cols="1"></v-col>
                                                <v-col cols="8" sm="12" md="12" lg="12">
                                                    <v-sheet min-width="600" max-width="1150">
                                                        <div
                                                            class="d-sm-flex d-md-flex d-lg-flex flex-wrap justify-left bg-background">
                                                            <ProductCard :products="productList" />
                                                        </div>
                                                    </v-sheet>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                        <!--Products Web View-->

                                    </v-window-item>
                                </v-window>
                            </v-col>
                        </v-row>
                    </v-card>
                    <!--Web View Tab screen End-->
                    <!--Mobile View Tab screen-->
                    <v-card elevation="0"
                        class="bg-background  rounded-xl mx-auto d-block d-sm-none d-md-none d-lg-none mt-n8"
                        max-width="1100">
                        <v-row dense>
                            <v-col cols="12">
                                <v-tabs v-model="categoryTab" bg-color="primary" slider-color="primary" color="white"
                                    grow selected-class="category-active" class="category-tab mobile-tab rounded-xl"
                                    height="38" show-arrows>
                                    <v-tab value="tab-all" elevation="0" hide-slider @click="categoryProduct('all')"
                                        class="rounded-xl">
                                        <!--<v-avatar class="mr-3">
                                            <v-img cover
                                                src="https://gourmetgarden.in/cdn/shop/files/Veg_3-min.jpg?v=1637668655">
                                            </v-img>
                                        </v-avatar>-->
                                        ALL
                                    </v-tab>
                                    <v-tab v-for="subCategory in subCategoryList" :key="subCategory.id"
                                        :value="'tab-' + subCategory.id" elevation="0"
                                        @click="categoryProduct(subCategory.id)" class="rounded-xl" hide-slider>
                                        <!--<v-avatar class="mr-3">
                                            <v-img cover :src="subCategory.image">
                                            </v-img>
                                        </v-avatar>-->
                                        {{ subCategory.name }}
                                    </v-tab>
                                </v-tabs>
                            </v-col>
                        </v-row>
                        <v-row dense class="mx-auto">
                            <v-col cols="12" sm="12" md="12" lg="12">
                                <v-window v-model="categoryTab">
                                    <!--All Product Tab-->
                                    <v-window-item value="tab-all">
                                        <!--Products mobile View-->
                                        <v-row dense no-gutters>
                                            <v-col cols="12">
                                                <v-sheet min-width="330" max-width="1100">
                                                    <div
                                                        class="d-flex d-sm-flex d-md-flex d-lg-flex flex-wrap align-content-left justify-left align-left bg-background">
                                                        <ProductCard :products="productList" />
                                                    </div>
                                                </v-sheet>
                                            </v-col>
                                        </v-row>
                                        <!--Products mobile View-->
                                    </v-window-item>
                                    <!--All Product Tab End-->
                                    <v-window-item v-for="subCategory in subCategoryList" :key="subCategory.id"
                                        :value="'tab-' + subCategory.id">
                                        <!--Products mobile View-->
                                        <v-row dense no-gutters>
                                            <v-col cols="12">
                                                <v-sheet min-width="330" max-width="1100">
                                                    <div
                                                        class="d-flex d-sm-flex d-md-flex d-lg-flex flex-wrap align-content-left justify-left align-left bg-background">
                                                        <ProductCard :products="productList" />
                                                    </div>
                                                </v-sheet>
                                            </v-col>
                                        </v-row>
                                        <!--Products mobile View-->

                                    </v-window-item>
                                </v-window>
                            </v-col>
                        </v-row>
                    </v-card>
                    <!--Mobile View Tab screen End-->


                </v-col>

            </v-row>
        </v-container>
        <!--category-->

        <AppFooter />
    </div>
</template>

<style>
.category-title-text {
    font-size: 35px;
}

.mobile-category-title-text {
    font-size: 22px;
}

.category-tab {
    border-radius: 10px;
}

.mobile-tab .v-tab {
    font-size: 10px !important;
}

.category-active {
    background-color: #000 !important;
    color: #fff !important;
}
</style>

<script>
// @ is an alias to /src
import AppMainCategory from '@/components/MainCategoryList.vue'
import TopBar from '@/components/Bar.vue'
import ProductCard from '@/components/Product.vue'
import AppFooter from '@/components/Footer.vue'
import { mapActions, mapGetters } from "vuex";
export default {
    name: 'CategoryView',
    data: () => ({
        categoryTab: 'tab-all',
    }),
    components: {
        TopBar,
        AppMainCategory,
        ProductCard,
        AppFooter,
    },
    created() {
        // // console.log(this.$route.params.id);
        // //console.log(this.$route.params.subid);
        // //category based product show when page open
        // this.getSubCategory(this.$route.params.id);
        // //this.tab = this.$route.params.subid;
        // this.categoryProduct(this.$route.params.subid);
        //router change show the products


        this.$watch(
            () => this.$route.params,
            () => {

                this.getSubCategory(this.$route.params.id);
                this.categoryProduct(this.$route.params.subid);
                this.categoryTab = 'tab-' + this.$route.params.subid;
                this.getCategoryDetails(this.$route.params.id);
            },
            // fetch the data when the view is created and the data is
            // already being observed
            { immediate: true }
        )
        setTimeout(() => {
            this.categoryTab = 'tab-' + this.$route.params.subid;
        }, 2000);

        this.getlocationDetails();

    },
    computed: {
        ...mapGetters([
            "subCategoryList",
            "productList",
            "categoryDetails",
            "locationDetails",

        ]),
        categoryDetail: function () {
            return this.categoryDetails;
        }
    },
    methods: {
        ...mapActions([
            "getSubCategory",
            "getProduct",
            "getCategoryDetails",
            "getlocationDetails",
        ]),
        categoryProduct(id) {
            this.categoryTab = 'tab-' + id;
            var subCatId = ''
            if (id != 'all') {
                subCatId = id;
            }
            const categoryData = {
                categoryId: this.$route.params.id,
                subCategoryId: subCatId,
                search: '',
            };
            //console.log(categoryData);
            this.getProduct(categoryData);
        },

    },
}
</script>
